import Reports from '../SuperAdmin/Reports';
export default Reports;
